module.exports = __webpack_public_path__ + "static/media/date.521d3037.svg";